import React, { useState, useEffect } from 'react';
import useDateRangeFilter from '../../../../hooks/useDateRangeFilter';
import Campaign from '../../../../templates/Campaign/Campaign';
import { Link } from 'react-router-dom';
import Loading from '../../../../templates/UI/Loading/Loading';
import moment from 'moment';
import useCallApi from '../../../../hooks/useCallApi';
import Dollars from '../../../../templates/Dollars/Dollars';
import MonitoringRatesDetail from '../MonitoringRatesDetails/MonitoringRatesDetails';
import DateRangeFilter from '../../../Reports/Filters/DateRangeFilter/DateRangeFilter';
import numberSort from '../../../../helpers/numberSort'
import ReportTable from '../../../../templates/ReportTable/ReportTable';

export default function MonitoringRatesReport() {

    document.title = 'Campaign Health Monitoring - Rate Discrepancies Report';
    
    const { initStartDate, initEndDate, selectedStartDate, selectedEndDate, quickDate, handleChangeStart, handleChangeEnd, handleQuickDate } = useDateRangeFilter()
    
    const { dataLoaded, data, refetch, setData } = useCallApi(`campaignHealthMonitoring/rates?startDate=${selectedStartDate}&endDate=${selectedEndDate}`, 'GET', {}, [])

    const [modalData, setModalData] = useState({open: false, campaignId: '', ratename: '', startDate: initStartDate, endDate: initEndDate, commission: 0});

    const [mbCommissionHidden, setMbCommissionHidden] = useState(false);

    const [ filteredData, setFilteredData ] = useState([]);

    const toggleMbCommission = () => {
        setMbCommissionHidden(!mbCommissionHidden);
    }

    useEffect(()=> {
        let filtered = mbCommissionHidden ? data.report.filter(item => item.ratename !== 'mb_commission') : data.report;
        setFilteredData(filtered);
    }, [data, mbCommissionHidden])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Campaign',
                accessor: 'campaign_name',
                Cell: (tableData) => {
                    return <Campaign oid={tableData.data[tableData.row.index].offer_id} name={tableData.data[tableData.row.index].name} status={tableData.data[tableData.row.index].status} />
                },
            },
            {
                Header: 'Ratename',
                accessor: 'ratename',
                 Cell: ({ cell: { value } }) => {
                    return <span className="badge badge-dark">{value}</span>
                },
            },
            {
                Header: 'Applied Ratename',
                accessor: 'applied_ratename',
                 Cell: ({ cell: { value } }) => {
                    return <span className="badge badge-info">{value}</span>
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Expected Aff</div>,
                sortType: numberSort,
                accessor: 'expected_aff_rate',
                className: 'text-right border-left',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Expected Net</div>,
                sortType: numberSort,
                accessor: 'expected_net_rate',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Aff Payout</div>,
                sortType: numberSort,
                accessor: 'affiliate_payout',
                className: 'text-right border-left',
                Cell: ({ cell: { value } }) => {
                    return <Dollars value={value} />
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Commission</div>,
                sortType: numberSort,
                accessor: 'commission_amount',
                className: 'text-right font-weight-bold',
                Cell: (tableData) => {
                    const item = tableData.data[tableData.row.index];
                    return <a  className={item.commission_amount > item.expected_net_rate ? 'text-success' : 'text-danger'}
                                href="#"
                                onClick={(e)=>{ e.preventDefault(); setModalData({open: true, campaignId: item.offer_id, ratename: item.ratename, startDate: selectedStartDate, endDate: selectedEndDate, commission: item.commission_amount}); }}>
                                    <Dollars value={item.commission_amount} />
                            </a>
                }
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Leads</div>,
                sortType: numberSort,
                accessor: 'lead_count',
                className: 'text-right border-left',
                Cell: ({ cell: { value } }) => {
                    return <>{value}</>
                },
            },
            {
                Header: () => <div style={{ textAlign: 'right' }}>Latest Lead</div>,
                sortType: numberSort,
                accessor: 'last_lead_date',
                className: 'text-right',
                Cell: ({ cell: { value } }) => {
                    return <>{moment.utc(value).format('YYYY-MM-DD HH:mm:ss')}</>
                },
            },
        ]        

        return (
            <React.Fragment>
                <ReportTable data={filteredData} columns={columns} />
            </React.Fragment>
        )
    }

    return (
        <>
        <div className="page-header d-flex align-items-center">
            <h1 className="mb-h1 d-flex align-items-center">
                <div>Rate Discrepancies Report</div>
            </h1>
        </div>
        <div className="row">
            <div className="col-xl-8">
                <div className="card mb-3 overflow-auto">
                    <div className="card-body p-0">
                        <MonitoringRatesDetail modalData={modalData} setModalData={setModalData} />
                        <div className="d-flex align-items-center p-3 flex-wrap">
                            <div className="d-flex align-items-center flex-wrap">
                                <DateRangeFilter quickDate={quickDate} selectedStartDate={selectedStartDate} selectedEndDate={selectedEndDate} handleChangeStart={handleChangeStart} handleChangeEnd={handleChangeEnd} handleQuickDate={handleQuickDate} />
                                <button onClick={refetch} className="btn btn-sm btn-primary mr-2">
                                    Refresh Report
                                </button>
                            </div>
                            <div className="ml-2 border rounded">
                                <label className="d-flex align-items-center my-auto p-1">
                                    <input type="radio" name="mb_commission" value="mb_commission" checked={mbCommissionHidden} onClick={()=>toggleMbCommission()} />
                                    <span className="ml-1">Hide <span className="badge badge-dark">mb_commission</span></span>
                                </label>                                
                            </div>
                        </div>
                        <div>{dataLoaded ? data.report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading></Loading>}</div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}